import { isNull } from 'lodash'
import { useMemo } from 'react'
import { useGetGeolocation } from '~map-search/queries/useGetGeolocation'

const validGeolocation = ({ lat, lng } = {}) => {
  if (isNull(lat)) return null
  if (isNull(lng)) return null
  return { lat, lng }
}

const defaultGeolocation = { lat: 0, lng: 0 }

const useCoords = () => {
  const { data: geolocation } = useGetGeolocation()

  const coords = useMemo(() => {
    return validGeolocation(geolocation) || defaultGeolocation
  }, [geolocation])

  return coords
}

export { useCoords }
